import { Image, Page, Text, View } from '@react-pdf/renderer';
import { useQuotePdfContext } from '@ui/pages/QuoteBuilder/hooks';
import { styles } from '@ui/pdfs/styles';

import { QuoteLink } from './components/QuoteLink';
import { TermsAndConditions } from './components/TermsAndConditions';
import { CustomerQuotePdfTemplate } from './template';

export function CustomerQuote() {
  const { quoteId } = useQuotePdfContext();
  return (
    <Page size="A4" style={styles.page}>
      <View style={styles.row}>
        <View style={[styles.section, styles.alignCenter]}>
          <Image
            src={'/images/WWP/WESTERN_WIRE_RGB_PRIMARY_LOGO_AW.png'}
            style={styles.logo}
          />
          <Text style={styles.textSmall}>ISO 9001:2015 certified</Text>
        </View>

        <View style={styles.section}>
          <Text style={styles.bold}>Western Wire</Text>
          <Text>770 Sunpark Drive</Text>
          <Text>Fenton, MO 63026</Text>
          <Text>Phone (800) 325 - 3770</Text>
          <Text>sales@westernwireusa.com</Text>
        </View>

        <View style={[styles.section, styles.alignCenter, styles.maxWidthFull]}>
          <Text style={[styles.quoteNumber, styles.bold]}>
            Quotation {quoteId}
          </Text>
          <Text style={styles.textSmall}>
            Please refer to the quotation number when ordering
          </Text>
          <QuoteLink />
        </View>
      </View>

      <View style={styles.row}>
        <View style={[styles.sectionHalf, { marginBottom: 4 }]}>
          <View style={styles.row}>
            <Text style={[styles.bold, styles.textReverse]}>
              Minimum Purchase:
            </Text>
          </View>
          <Text style={styles.textSmall}>
            $80.00 combined product total, per schedule release.
          </Text>
          <Text style={styles.textSmall}>
            Fees do not apply towards minimum.
          </Text>
        </View>

        <View style={[styles.sectionHalf, { marginBottom: 4 }]}>
          <View style={styles.row}>
            <Text style={[styles.bold, styles.textReverse]}>
              Made-to-Order Items:
            </Text>
          </View>
          <Text style={styles.textSmall}>
            Delivery quantity variance of +/- 5-10% may apply.
          </Text>
        </View>
      </View>

      <View style={styles.row}>
        <View style={[styles.fullRow, { marginBottom: 4 }]}>
          <View style={styles.row}>
            <Text style={[styles.bold, styles.textReverse]}>
              Certifications:
            </Text>
          </View>

          <Text style={styles.textSmall}>
            Certifications are optional. Fees are per item—unless specified
            otherwise—and apply to each requested release.
          </Text>
        </View>
      </View>

      <View style={styles.row}>
        <View style={[styles.fullRow, { marginBottom: 4 }]}>
          <View style={[styles.row, styles.justifyBetween]}>
            <Text style={[styles.bold, styles.textSmall]}>
              Non-Spring Pins:
            </Text>
            <Text style={styles.textSmall}>CofC: $35.00 per order</Text>
            <Text style={styles.textSmall}>Material: $30.00</Text>
            <Text style={styles.textSmall}>Plating: $55.00</Text>
            <Text style={styles.textSmall}>
              DFARS: $75.00 (includes CofC + Material Cert.)
            </Text>
          </View>

          <View style={[styles.row, styles.justifyBetween]}>
            <Text style={[styles.bold, styles.textSmall]}>
              Slotted Spring Pins:
            </Text>
            <Text style={styles.textSmall}>CofC: $60</Text>
            <Text style={styles.textSmall}>Material: $55.00</Text>
            <Text style={styles.textSmall}>Plating: $100.00</Text>
            <Text style={styles.textSmall}>DFARS: Not offered</Text>
            <Text style={styles.textSmall}>Dual Cert: $75.00</Text>
          </View>
        </View>
      </View>

      <View style={styles.row}>
        <View style={styles.fullRow}>
          <Text style={styles.textSmall}>
            For PPAP, ISIR, IMDS, FAIR (AS9102), or any other certification,
            please request quotation.
          </Text>
        </View>
      </View>

      <CustomerQuotePdfTemplate showPartDescription />

      <View style={styles.row}>
        <View style={styles.fullRow}>
          <Text>FOB: Origin</Text>
        </View>
      </View>

      <View style={styles.row}>
        <View style={styles.fullRow}>
          <Text style={[styles.textSmall, styles.bold]}>
            Items ordered as part of a blanket or multiple release agreement
            must be taken with 6 months manufacture. Quoted delivery subject to
            material availability at time of order . DFAR items subject to
            material availability at time of order.
          </Text>
        </View>
      </View>

      <View style={styles.row}>
        <View style={styles.fullRow}>
          <Text>View Your Order Status & Tracking Online:</Text>
          <Text>
            For updates on your order status and tracking information, log in to
            your account on MWComponents.com using the same email address
            associated with your order. Navigate to My Account, then select
            Orders. If you do not already have an account, you can create one.
            Orders associated with the account email address will automatically
            populate.
          </Text>
        </View>
      </View>

      <View style={styles.row}>
        <View style={styles.fullRow}>
          <TermsAndConditions />
        </View>
      </View>
    </Page>
  );
}
